import React from "react";
import { Input } from "../ui/input";

export const RANGES = [
  { key: "1", label: "Today" },
  { key: "7", label: "Last 7 days" },
  { key: "15", label: "Last 15 days" },
  { key: "30", label: "Last 30 days" },
  { key: "90", label: "Last 90 days" },
  { key: "custom", label: "Custom dates" },
];

// Plain text toggles — one tap to switch, the active range underlined.
export function RangePicker({ value, onChange, custom, onCustom, testid = "range" }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-4 flex-wrap text-xs">
        {RANGES.map((r) => (
          <button key={r.key} type="button" data-testid={`${testid}-${r.key}`}
            onClick={() => onChange(r.key)}
            className={`transition-colors ${value === r.key
              ? "text-primary font-semibold underline underline-offset-4"
              : "text-muted-foreground hover:text-neutral-800"}`}>
            {r.label}
          </button>
        ))}
      </div>
      {value === "custom" && (
        <div className="flex items-end gap-2 flex-wrap">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">From</div>
            <Input type="date" data-testid={`${testid}-start`} value={custom.start}
              onChange={(e) => onCustom({ ...custom, start: e.target.value })} className="h-9 w-40" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">To</div>
            <Input type="date" data-testid={`${testid}-end`} value={custom.end}
              onChange={(e) => onCustom({ ...custom, end: e.target.value })} className="h-9 w-40" />
          </div>
        </div>
      )}
    </div>
  );
}

export const fmtDay = (d) => (d
  ? new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "short" })
  : "—");

export const fmtLongDay = (d) => (d
  ? new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })
  : "—");

export function RangeNote({ range }) {
  if (!range) return null;
  return (
    <p className="text-[11px] text-muted-foreground mt-2" data-testid="tracking-note">
      Tracking since {fmtLongDay(range.tracking_start)}
      {range.empty
        ? " — this range ends before tracking began, so there is nothing to show"
        : range.clipped && " — earlier days in this range are not shown because nothing was tracked yet"}
    </p>
  );
}
